import { render, staticRenderFns } from "./filter-list.vue?vue&type=template&id=35d40c0e&"
import script from "./filter-list.vue?vue&type=script&lang=js&"
export * from "./filter-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RangePrice2: require('/var/www/components/range/range-price2.vue').default,RangeYear2: require('/var/www/components/range/range-year2.vue').default})
